import { render, staticRenderFns } from "./CompensationTypeDelete.vue?vue&type=template&id=8c974f26&scoped=true&"
import script from "./CompensationTypeDelete.vue?vue&type=script&lang=js&"
export * from "./CompensationTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c974f26",
  null
  
)

export default component.exports